import { useHelpCenter } from 'hooks/use-help-center';
import { useMemo } from 'react';

type UseHelpCenterFeature = {
  name: string;
  productType?: string;
  productSubtype?: string;
};
export function useHelpCenterFeature({ name, productSubtype, productType }: UseHelpCenterFeature) {
  const { getTopicById, openTopicId } = useHelpCenter();

  const featureTopicId = useMemo(() => {
    if (productType && productSubtype) {
      const topicId = `features.${productType}.${productSubtype}.${name}`;
      if (getTopicById(topicId)) {
        return topicId;
      }
    }

    if (productType) {
      const topicId = `features.${productType}.${name}`;
      if (getTopicById(topicId)) {
        return topicId;
      }
    }

    const topicId = `features.${name}`;
    if (getTopicById(topicId)) {
      return topicId;
    }

    return undefined;
  }, [getTopicById, productType, productSubtype, name]);

  const exists = Boolean(featureTopicId);

  const open = () => featureTopicId && openTopicId(featureTopicId);

  return { exists, open };
}
